import React, { useEffect, useState } from 'react';
import { Button } from '@monavate/ui-core';
import { cardsApi } from '@/services/rest/apiInstances';
import { ClickToCopy } from '@monavate/ui-core';
import { returnCardNumber } from '@/helpers/returnCardNumber';
import styled from 'styled-components';
import { CardResponse } from '@/api/general';
import { buildClientApiConfig } from '@/helpers/apiRequestConfig';
import { Tooltip } from '@monavate/ui-core';

const Wrapper = styled.div`
    margin-top: -5px;
    .material-symbols-sharp {
        width: 22px;
        height: 22px;
        font-weight: 300;
        color: ${(props) => props.theme['Content/primary']};
    }
    .col {
        display: inline-block;
        vertical-align: middle;
        text-transform: capitalize;
    }
`;

interface CardNumberProps {
    cardData: any;
}
const CardNumberSecurity: React.FC<CardNumberProps> = ({ cardData }) => {
    const [isShowSecureCardInfo, setIsShowSecureCardInfo] = useState(false);
    const [secureCardData, setSecureCardData] = useState<CardResponse | undefined>(cardData);
    const fetchCardDetails = async (cardId: string, includeSecureInfo: boolean) => {
        const options = buildClientApiConfig();
        const response = await cardsApi.getCard(
            {
                // @ts-ignore
                cardId: cardId,
                includeSecureInfo: includeSecureInfo,
            },
            options,
        );
        if (response.data) {
            setSecureCardData(response.data);
        }
    };
    useEffect(() => {
        fetchCardDetails(cardData.id, isShowSecureCardInfo);
    }, [isShowSecureCardInfo]);
    return (
        <Wrapper>
            <span className="col">
                <ClickToCopy
                    dataTestId="card-number-security-copy"
                    disableClickToCopyLogic={!isShowSecureCardInfo}
                >
                    <span data-test-id="value-card-number">
                        {returnCardNumber(secureCardData, isShowSecureCardInfo)}
                    </span>
                </ClickToCopy>
            </span>
            <span className="col">
                <Tooltip title="See card details" placement="top">
                    <Button
                        dataTestId="button-toggle-card-details"
                        size={'small'}
                        viewType={'tertiary'}
                        style={{ padding: '4px', marginLeft: '16px' }}
                        handleClick={() => {
                            setIsShowSecureCardInfo(!isShowSecureCardInfo);
                        }}
                    >
                        {isShowSecureCardInfo ? (
                            <span className="material-symbols-sharp">visibility</span>
                        ) : (
                            <span className="material-symbols-sharp">visibility_off</span>
                        )}
                    </Button>
                </Tooltip>
            </span>
        </Wrapper>
    );
};

export default CardNumberSecurity;
